export default {
    'SET_USER' (state, payload) {
        state.user = payload
    },
    'SET_AUTH' (state, payload) {
        state.auth = payload
    },
}


// WEBPACK FOOTER //
// ./src/vuex/mutations.js